var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleLoader = function SvgCircleLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.303 446.11c80.412 21.547 166.089-7.538 216.768-73.584 50.679-66.045 56.616-156.333 14.992-228.428-41.624-72.096-122.789-112.19-205.325-101.323C138.201 53.641 70.13 113.37 48.583 193.781a29.436 29.436 0 1 0 56.854 15.21A147.06 147.06 0 0 1 228.415 101.15c59.098-7.78 116.856 20.73 146.661 72.352 29.804 51.622 25.568 115.884-10.719 163.174a147 147 0 0 1-154.845 52.581 29.436 29.436 0 1 0-15.209 56.853"
  })));
};
export default SvgCircleLoader;